/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : LegalRequirementLinkHome.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React, { useState } from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { componentStyle } from "../../../config/appTheme";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LRtoComponentTemplate from "./LRtoComponentTemplate";
import LrAsAnchorLegalRequirementCardTemplate from "./LrAsAnchorLegalRequirementCardTemplate";

function LegalRequirementLinkHome() {
  const [cardOpen, setCardOpen] = useState(true);
  const [selectedLrReqNumber, setSelectedLrReqNumber] = useState(
    "Select Legal Requirement",
  );
  const [selectedLrId, setSelectedLrId] = useState(null);

  const transitionStyle = {
    transition: "width 0.4s ease-in-out, height 0.4s ease-in-out",

    display: "flex",
    flexDirection: "column",
  };

  const closedHeight = "3rem";
  const openHeight = "30rem";
  return (
    <Box>
      <Grid container>
        <Grid
          item
          sm={5}
          sx={{
            ...transitionStyle,
            height: cardOpen ? openHeight : closedHeight,
            minWidth: cardOpen ? "auto" : "0px",
          }}
        >
          {!cardOpen && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
                alignItems: "center",
                backgroundColor: "#000000",
                color: "#ffffff",
              }}
            >
              <Typography sx={{ ...componentStyle.font.cardHeadder }}>
                {selectedLrReqNumber}
              </Typography>
              <Box
                onClick={() => {
                  setCardOpen(true);
                }}
                sx={{ cursor: "pointer" }}
              >
                <KeyboardArrowDownIcon />
              </Box>
            </Box>
          )}

          <Box
            sx={{
              flexGrow: 1,
              opacity: cardOpen ? 1 : 0, // Fade content out/in
              transition: "opacity 0.3s ease-in-out 0.1s",
            }}
          >
            <LrAsAnchorLegalRequirementCardTemplate
              setCardOpen={setCardOpen}
              getSelectedLrDetails={(lrId, lrDetails) => {
                console.log("---getSelectedLrDetails---", lrId, lrDetails);
                setSelectedLrReqNumber(lrDetails?.req_number);
                setSelectedLrId(lrId || lrDetails?.lr_id || null);
              }}
            />
          </Box>
        </Grid>

        {cardOpen && (
          <Grid
            sm={0.2}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: -1,
              pt: -1,
            }}
          >
            <Divider
              sx={{
                border: cardOpen ? "1px solid #6B7280" : "none",
                height: "26rem",
                ml: 0.5,

                width: "1px",
              }}
            />
          </Grid>
        )}

        <Grid
          item
          sm={cardOpen ? 6.8 : 12}
          sx={{
            ...transitionStyle,
            height: openHeight,
            position: "relative",
          }}
        >
          <Box
            sx={{
              height: "100%",
              padding: "10px",
            }}
          >
            <LRtoComponentTemplate selectedLrId={selectedLrId} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default LegalRequirementLinkHome;
